import './resizeObserverGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { store, persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import './index.css';
import App from './App';
import { Provider } from 'react-redux';
import { CssVarsProvider, getInitColorSchemeScript } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import theme from './assets/theme/theme';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    {getInitColorSchemeScript({ modeStorageKey: 'app-color-scheme' })}
    <CssVarsProvider theme={theme} defaultMode="dark" modeStorageKey="app-color-scheme">
      <CssBaseline />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    </CssVarsProvider>
  </React.StrictMode>
);
